import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  input: {
    minHeight: 45,
    maxHeight: 'auto',
    backgroundColor: '#f8f4f4',
    paddingLeft: 12,
    borderRadius: 3,
    marginBottom: 5,
    fontFamily: 'circular-std',
    fontSize: 16,
    textTransform: 'capitalize',
    color: '#3f3a40',
    width: '100%',
  },
  selectLabel: {
    lineHeight: 24,
    fontWeight: '500',
    fontSize: 16,
    marginBottom: 10,
  },
  button: {
    paddingVertical: 10,
    alignSelf: 'center',
  },

  buttonSmall: {
    alignSelf: 'center',
  },
  clearButtonContainer: {
    paddingVertical: 4,
    paddingLeft: 4,
    paddingRight: 21,
    backgroundColor: '#f8f4f4',
    borderRadius: 8,
    marginBottom: 15,
  },
  saveButtonContainer: {
    paddingVertical: 4,
    paddingLeft: 4,
    paddingRight: 21,
    borderRadius: 8,
    marginBottom: 15,
  },

  smallclearButtonContainer: {
    paddingLeft: 4,
    paddingRight: 21,
    backgroundColor: '#f8f4f4',
    borderRadius: 8,
    marginBottom: 25,
    height: 45,
  },
  smallsaveButtonContainer: {
    paddingLeft: 4,
    paddingRight: 21,
    borderRadius: 8,
    marginBottom: 25,
    height: 45,
  },
  actionButtonTextContainer: {
    paddingHorizontal: 8,
    paddingVertical: 8,
  },
  saveButtonText: {
    color: '#FFFFFF',
    justifyContent: 'center',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 20,
    marginLeft: 15,
    alignSelf: 'center',
  },
  clearButtonText: {
    color: '#3f3a40',
    justifyContent: 'center',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 20,
    marginLeft: 15,
    alignSelf: 'center',
  },
});
